import React from "react";

import { LoyaltyStoreAccess } from "../../../../store";
import { RedeemIncentiveOTPConfirmed } from "./OTPConfirmed";
import { RedeemIncentiveModalProps } from "..";
import { RedeemIncentiveOTPConfirmation } from "./OTPConfirmation";

export interface RedeemIncentiveOTPProps extends RedeemIncentiveModalProps {
  closeIncentivesModal: () => void;
}
export const RedeemIncentiveOTP = ({ incentive, closeIncentivesModal }: RedeemIncentiveOTPProps) => {
  const redeemedIncentives = LoyaltyStoreAccess.useRedeemedIncentives();
  const foundRedeemedIncentive = redeemedIncentives.find(
    redeemedIncentive => redeemedIncentive.id === incentive.id
  );
  const discountCode = foundRedeemedIncentive?.discountCode ?? "";

  return (
    <React.Fragment>
      {foundRedeemedIncentive?.discountCode ? (
        <RedeemIncentiveOTPConfirmed
          incentive={incentive}
          closeIncentivesModal={closeIncentivesModal}
          discountCode={discountCode}
        />
      ) : (
        <RedeemIncentiveOTPConfirmation incentive={incentive} closeIncentivesModal={closeIncentivesModal} />
      )}
    </React.Fragment>
  );
};
